import { render, staticRenderFns } from "./publicSettingsPage.vue?vue&type=template&id=2b5689c8&scoped=true"
import script from "./publicSettingsPage.vue?vue&type=script&lang=js"
export * from "./publicSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./publicSettingsPage.vue?vue&type=style&index=0&id=2b5689c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5689c8",
  null
  
)

export default component.exports